import { render } from "./AddKitaDialog.vue?vue&type=template&id=23fd90a2"
import script from "./AddKitaDialog.vue?vue&type=script&lang=js"
export * from "./AddKitaDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__